import { useViewport } from '@chilecompra/react-kit'
import { Button, Card, Typography } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'

import { REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../../config/settings/environment.config'
import { Container } from '../Claims.styles'

/**
 * The ClaimsSuccess component.
 */
const ClaimsSuccess = ({ code }) => {
  const { size } = useViewport()

  const isTiny = size.isTiny

  const handleCheckStatus = () => {
    window.location.href = `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Site/Reclamos/Prov/ProvBuscadorReclamos.aspx`
  }

  return (
    <Card color="blank" enableBorder padding="48px 24px">
      <Container alignItems="center" direction="column" spacing={4}>
        <Container
          alignItems="center"
          direction="column"
          spacing={2}
          style={{ textAlign: 'center' }}
        >
          <Typography fontWeight="bold" variant="h3">
            ¡Tu reclamo ha sido ingresado con éxito!
          </Typography>

          <Typography variant="body1">
            Puedes revisar el estado de tu reclamo con el siguiente número de seguimiento:
          </Typography>
        </Container>

        <Typography color="success" fontWeight="bold" variant="h2">
          {code || '-'}
        </Typography>

        <Button
          color="primary"
          onClick={handleCheckStatus}
          padding="0 16px"
          variant="contained"
          width={isTiny ? '100%' : '300px'}
        >
          Revisar el estado de mi reclamo
        </Button>
      </Container>
    </Card>
  )
}

ClaimsSuccess.propTypes = {
  code: PropTypes.string.isRequired
}

export default ClaimsSuccess
